<script lang="ts">
  import { AppState } from '../../etc/stores';
  import WidgetCoin from './WidgetCoin.svelte';
  import WidgetCoupon from './WidgetCoupon.svelte';
  import WidgetGift from './WidgetGift.svelte';
  import WidgetTrophy from './WidgetTrophy.svelte';
  import WidgetWallet from './WidgetWallet.svelte';

  const defaultIcon = 'coin';

  const { widgetStyleIcon = defaultIcon } = $AppState.settings;

  const component = {
    coupon: WidgetCoupon,
    gift: WidgetGift,
    wallet: WidgetWallet,
    coin: WidgetCoin,
    trophy: WidgetTrophy
  };
</script>

<svelte:component this={component[widgetStyleIcon] || component[defaultIcon]} />
